module.exports = function getResource (label, vars = []) {
    let resources = {
        confirmBasketUpdateModalTitle: 'Confirmation',
        confirmBasketUpdateModalButtonText: 'Continuer',
        sureToContinueMessage: 'Souhaitez-vous vraiment continuer?',
        error: 'Erreur',
        ok: 'OK'
    };
    return resources[label];
};
